import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { ContentComponent } from './content/content.component'
import { Content } from '@monorepo/golab-generated'

@Component({
  selector: 'app-content-list',
  templateUrl: './content-list.component.html',
  styleUrls: ['./content-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ContentComponent],
})
export class ContentListComponent {
  @Input() contentList: Content[] = []
  @Input() phaseId: string = ''
}
